// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Email_wrap__bX66J","input":"Email_input__qNiWf","label":"Email_label__oUftO"};